import React from 'react';

import { formatDate } from '../../../utils';

import AttendeePanel from './attendeePanel';
import { ExtendedEvent, getAssetsFile } from './getData';

interface Props {
  event: ExtendedEvent;
}

const EventDetailsPanel: React.FC<Props> = (props) => {
  const { event } = props;

  return (
    <AttendeePanel className="w-2/5 items-center text-center">
      <img
        className="w-52 aspect-square rounded-md object-cover"
        src={getAssetsFile('logo.png', event.eventId)}
        alt={`${event.name} Logo`}
      />

      <div className="text-xl font-bold">{event.name}</div>

      {event.startDate && event.endDate && (
        <div>
          {event.startDate === event.endDate
            ? formatDate(event.startDate)
            : `${formatDate(event.startDate)} – ${formatDate(event.endDate)}`}
        </div>
      )}
    </AttendeePanel>
  );
};

export default EventDetailsPanel;
